"use client";

import * as React from "react";

// Style toggle parked while Claude is the only active style.
// import { StyleToggle } from "./style-toggle";

const NAV_ITEMS = [
  { href: "hey", label: "Intro" },
  { href: "projects", label: "Work" },
  { href: "story", label: "Letter" },
  { href: "vibes", label: "Notes" },
];

function scrollToSection(href: string) {
  const element = document.querySelector(
    `[data-name="${href}"]`
  ) as HTMLElement | null;
  element?.scrollIntoView({ behavior: "smooth" });
}

export function Navbar() {
  const [scrolled, setScrolled] = React.useState(false);
  const [activeSection, setActiveSection] = React.useState("hey");

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 24);

      const sections = document.querySelectorAll("section[data-name]");
      let current = "hey";
      sections.forEach((section) => {
        const el = section as HTMLElement;
        if (window.pageYOffset >= el.offsetTop - el.clientHeight / 3) {
          current = section.getAttribute("data-name") || "hey";
        }
      });
      setActiveSection(current);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`
        nav-shell fixed left-0 right-0 top-0 z-[99]
        ${scrolled ? "nav-shell-scrolled" : ""}
      `}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 md:px-6">
        <button
          type="button"
          onClick={() => scrollToSection("hey")}
          className="font-display text-xl font-semibold italic tracking-tight text-style-heading transition-colors hover:text-style-accent"
        >
          Gerardo&nbsp;<span className="text-style-accent not-italic">✦</span>
        </button>

        <ul className="flex items-center gap-1 sm:gap-2">
          {NAV_ITEMS.map((item) => {
            const isActive = item.href === activeSection;
            return (
              <li key={item.href}>
                <button
                  type="button"
                  onClick={() => scrollToSection(item.href)}
                  className={`
                    relative px-2.5 py-2 font-mono text-[11px] uppercase tracking-[0.18em]
                    transition-colors duration-300 sm:px-3.5
                    ${isActive ? "text-style-heading" : "text-style-muted hover:text-style-body"}
                  `}
                >
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-[var(--style-accent)]" />
                  )}
                </button>
              </li>
            );
          })}
        </ul>
        {/* Style toggle parked — re-add <StyleToggle /> here to restore it. */}
      </div>
    </nav>
  );
}
